import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ReportTools} from './reportTools.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';

/* global customElements */
class ReportGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean},
			widgetmode: {type: Boolean}
		};
	}
	
	constructor() {
		super();
				
		this.admin = false;
		this.widgetmode = false;
				
		var reportGrid = this;
		setTimeout(function(){
			reportGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var reportGrid = this;

		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (reportGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {						
						if (reportGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							if (reportGrid.admin) {								
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
								if (selectedCompany) {
									ElementUtil.query(toolbar, 'generate').disabled = false;
									ElementUtil.query(toolbar, 'upload').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'generate').disabled = true;
									ElementUtil.query(toolbar, 'upload').disabled = true;
								}
							}
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterReportType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By Report Type',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Filter Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startCurrentMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'Filter End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());	
					}()
				},
				{
					tag: 'vaadin-checkbox',
					itemid: 'filterFinalized',
					label: 'Finalized Only'
				},
				{
					tag: 'vaadin-checkbox',
					itemid: 'filterShowCompanies',
					style: 'display: none;',
					label: 'Show Company Reports'
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					itemId: 'mainToolSeparator-refresh',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'generate',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_REPORTS:WRITE', 'REPORTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:cogs', ' Generate')						
					],
					listeners: {
						click: function() {
							actionGenerate();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_REPORTS:READ', 'REPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:file-text-o', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					itemId: 'mainToolSeparator',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'download',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_REPORTS:READ', 'REPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')						
					],
					listeners: {
						click: function() {
							actionDownload(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'scheduled',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_SCHEDULED_REPORTS:READ', 'SCHEDULED_REPORTS:READ'],
							style: '' + (reportGrid.admin ? 'display: none;' : ''),
							children:[
								ElementUtil.makeIcon('vaadin:timer', 'Scheduled')						
							],
							listeners: {
								click: function() {
									actionScheduled();
								}
							}							
						},
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_REPORTS:WRITE', 'REPORTS:WRITE'],							
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Upload')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							itemId: 'mainToolSeparator-delete',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_REPORTS:DELETE', 'REPORTS:DELETE'],
							'class': 'spacer-toolbar-item',
							disabled: true,
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}		
			]
		});	
		
		if (reportGrid.admin) {
			ElementUtil.query(toolbar, 'upload').disabled = true;
			ElementUtil.query(toolbar, 'generate').disabled = true;
		}
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'reportTypeDescription',
					header: 'Report Type',
					width: '7em'
				},	
				{						
					path: 'reportBeginDts',
					header: 'Begin Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.reportBeginDts) {
							var date = TimeUtil.parseDate(rowData.item.reportBeginDts);						
							root.innerHTML = TimeUtil.formatReportPeriodDate(date, true);						
						} else {
							root.innerHTML = 'N/A';						
						}
					}
				},
				{						
					path: 'reportEndDts',
					header: 'End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.reportEndDts) {
							var date = TimeUtil.parseDate(rowData.item.reportEndDts);						
							root.innerHTML = TimeUtil.formatReportPeriodDate(date, false);						
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},				
				{						
					path: 'unitSelectionTypeDescription',
					header: 'Unit Selection Type',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.unitSelectionTypeDescription) {
							root.innerHTML = rowData.item.unitSelectionTypeDescription;
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},												
				{						
					path: 'runStatus',
					header: 'Status',
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						if (rowData.item.runStatus === 'FAILED') {
							root.style.backgroundColor = '#b87373';
						} else if (rowData.item.runStatus === 'COMPLETE-WARNING') {
							root.style.backgroundColor = '#8d8d4a';
						} else if (rowData.item.status === 'PENDING') {
							root.style.backgroundColor = 'aliceblue';
						} else if (rowData.item.status === 'CANCELED') {
							root.style.backgroundColor = 'lightgrey';
						} else if (rowData.item.status === 'SUSPENDED') {
							root.style.backgroundColor = 'beige';
						} else if (rowData.item.status === 'GENERATING') {
							root.style.backgroundColor = 'lightgreen';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.runStatusDescription;
					}
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					direction: 'desc',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'generatedForUser',
					header: 'Generated For User',
					width: '7em'
				},
				{						
					path: 'flags',
					header: 'Flags',
					'text-align': 'center',
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = '';
						var wrapper = document.createElement('span');
						wrapper.style.display = 'inline-flex';
						wrapper.style.alignItems = 'center';
						wrapper.style.flexWrap = 'wrap';
						wrapper.style.gap = '0.35em';
						wrapper.style.justifyContent = 'center';
						
						var item = rowData.item;
						var exceptionCount = item.exceptionCount;
						if (exceptionCount == null && item.summary && item.summary.metaData) {
							var countValue = item.summary.metaData['Exception Count'];
							if (countValue != null && countValue !== '') {
								exceptionCount = parseInt(countValue, 10);
							}
						}
						if (exceptionCount != null && !isNaN(exceptionCount)) {
							var exceptionIcon = document.createElement('vaadin-icon');
							if (exceptionCount === 0) {
								exceptionIcon.setAttribute('icon', 'vaadin:check');
								exceptionIcon.style.color = 'var(--lumo-success-color)';
								exceptionIcon.title = 'No exceptions';
							} else {
								exceptionIcon.setAttribute('icon', 'vaadin:close-small');
								exceptionIcon.style.color = 'var(--lumo-error-color)';
								exceptionIcon.title = exceptionCount + ' exception(s)';
							}
							wrapper.appendChild(exceptionIcon);
						}
						
						var flags = [];
						if (item.manualUploaded) {
							flags.push('Uploaded');
						}
						if (item.finalized) {
							flags.push('Finalized');
						}
						if (item.scheduled) {
							flags.push('Scheduled');
						}
						if (flags.length > 0) {
							wrapper.appendChild(document.createTextNode(flags.join(', ')));
						}
						
						root.appendChild(wrapper);
					}
				},			
				{
					path: 'expiresInDays',
					header: 'Expires',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData)  {
						var days = rowData.item.expiresInDays;
						if (days < 0) {
							root.innerHTML = "Never";
						} else if (days === 0) {
							root.style.backgroundColor = '#ffbdbd';
							root.innerHTML = "< 1 day";
						} else if (days <= 3) {
							root.style.backgroundColor = 'ffbdbd';
							root.innerHTML = days + ' day(s)';
						} else if (days > 3 && days < 7) {
							root.style.backgroundColor = 'yellow';
							root.innerHTML = days + ' days';
						} else {
							root.style.backgroundColor = '';
							root.innerHTML = days + ' days';
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {					  
						ElementUtil.query(toolbar, 'details').disabled = false;
						
						if (item.completedDts) {
							ElementUtil.query(toolbar, 'delete').disabled = false; 
						} else {
							ElementUtil.query(toolbar, 'delete').disabled = true; 
						}
						
						if (item.downloadAvailable) {
							ElementUtil.query(toolbar, 'download').disabled = false; 
						} else {
							ElementUtil.query(toolbar, 'download').disabled = true; 
						}												
					} else {						
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true; 
						ElementUtil.query(toolbar, 'download').disabled = true;						
					}
				}
			}
		});	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
										
						var selectedCompany = null;
						if (reportGrid.admin) {
							selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							
							if (!selectedCompany) {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Validation', 'Select a company first.', {									
										theme: 'error'
								});
								return;
							}
						}
						
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);	
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'DESC',
							start: startFilterDts,
							end: endFilterDts,
							dateField: 'updateDts'
						};
						
						var filterReportType = ElementUtil.query(toolbarFilter, 'filterReportType').value;
						if (filterReportType) {
							grid.currentFilter.filterField = 'reportTypeDescription';
							grid.currentFilter.filterValue = filterReportType;
						}
						
						if (selectedCompany) {
							grid.currentFilter.companyId = selectedCompany;
						}
						
						var finalized = ElementUtil.query(toolbarFilter, 'filterFinalized');
						if (finalized) {
							grid.currentFilter.finalized = finalized.checked;
						}
						
						var showCompanyReports = ElementUtil.query(toolbarFilter, 'filterShowCompanies').checked;
						if (showCompanyReports) {
							grid.currentFilter.showCompanyReports = ElementUtil.query(toolbarFilter, 'filterShowCompanies').checked;
						}						

						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						Service.getReportService().getReports(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {		
					if (!reportGrid.admin) {
						pagingToolbar.loadCurrentPage();					
					}
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getReportService().exportReports(exportFilter);
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		reportGrid.append(flexLayout);
		
		if (reportGrid.widgetmode) {
			setTimeout(function(){
				ElementUtil.query(toolbar, 'generate').classList.add('hide');
				ElementUtil.query(toolbar, 'details').classList.add('hide');
				ElementUtil.query(toolbar, 'download').classList.add('hide');
				ElementUtil.query(toolbar, 'scheduled').classList.add('hide');
				ElementUtil.query(toolbar, 'upload').classList.add('hide');
				ElementUtil.query(toolbar, 'delete').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator-refresh').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator-delete').classList.add('hide');
				toolbarFilter.classList.add('hide');
			});
		}		
			
		var showCompanyReportsFilter = function() {
			if (!reportGrid.admin) {
				Service.getUserService().getCurrentUser().then(function(user){
					if(user.hasPermission('REPORTS:VIEW_COMPANY_RESOURCE')) {
						ElementUtil.query(toolbarFilter, 'filterShowCompanies').style = '';
					}
				});
			}
		};		
		showCompanyReportsFilter();
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(reportGrid, toolbarFilter, ['filterCompany','filterReportType','filterStartDate','filterEndDate','filterFinalized','filterShowCompanies'], actionRefresh);
				
		var actionScheduled = function() {
			var scheduleWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Scheduled Reports',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						scheduleWin.show();
						
						var scheduledGrid = ElementUtil.create({
							tag: 'dl-scheduled-report-grid',
							listeners: {
								cancel: function() {
									scheduleWin.close();
								},
								success: function() {
									actionRefresh();
									scheduleWin.close();
								}
							}
						});
				
						
						scheduleWin.addToContentElement(scheduledGrid);
					}
				}
			});						
		};
		
		var actionGenerate = function() {
						
			var generateWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Generate Report',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						generateWin.show();
						
						var genForm = ElementUtil.create({
							tag: 'dl-report-generate-form',
							listeners: {
								cancel: function() {
									generateWin.close();
								},
								success: function() {
									actionRefresh();
									generateWin.close();
								}
							}
						});
						if (reportGrid.admin) {
							var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
							genForm.setCompanyId(selectedCompany);
						} else {
							Service.getCompanyService().getCurrentCompany().then(function(companyAll){								
								genForm.setCompanyId(companyAll.company.companyId);
							});
						}
						
						generateWin.addToContentElement(genForm);
					}
				}
			});
			
		};			
		
		var reportCompanyId = function(record) {
			if (record && record.companyId) {
				return record.companyId;
			}
			if (reportGrid.admin) {
				return ElementUtil.query(toolbarFilter, 'filterCompany').value;
			}
			return null;
		};

		var actionDetails = function(record) {
			var companyId = reportCompanyId(record);
			ReportTools.viewReportDetails(function(updateHandler){
				Service.getReportService().getReportDetails(record.reportId, companyId).then(function (details) {
					updateHandler(details);
				});
			}, function(successHandler, unitFilter){
				Service.getReportService().getReportUnits(record.reportId, unitFilter, companyId).then(function (records) {
					successHandler(records);
				});
			}, record.reportId, function(successHandler, groupFilter){
				Service.getReportService().getReportBulkGroups(record.reportId, groupFilter, companyId).then(function (records) {
					successHandler(records);
				});
			}, companyId);
		};			
		
		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Upload Report',
				icon: 'vaadin:upload',
				width: 800,
				height: 425,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A report file is required.');
							} else if (reportGrid.admin) {						
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
								if (!selectedCompany) {
									window.DL.MessageUtil.showOkMessage('Company Selection is required.');
								} else {
									uploadField.uploadFiles();
								}
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var selectedReportType;
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',										
										children: [		
											{											
												tag: 'vaadin-combo-box',
												itemid: 'reportType',
												name: 'reportType',
												colspan: 2,												
												label: 'Report Type',
												'item-value-path': 'reportType',
												'item-label-path': 'reportTypeDescription',
												postinit: function(combo) {
													Service.getReportService().getReportDefinitions().then(function(data){
														combo.items = data;
														combo.required = true;
													});
												},
												listeners: {
													change: function(event) {
														selectedReportType = this.selectedItem; 
													}
												},
												placeHolder: 'Select'
											},
											{
												tag: 'vaadin-text-field',
												name: 'note',											
												label: 'Note',
												required: true,
												colspan: 2,
												maxLength: 255												
											},
											{
												tag: 'vaadin-date-time-picker',
												label: 'Report Start Date',
												name: 'reportBeginDts'
											},
											{
												tag: 'vaadin-date-time-picker',
												label: 'Report End Date',
												name: 'reportEndDts'
											},
											{
												tag: 'vaadin-checkbox',
												name: 'finalized',
												label: 'Finalized'
											},
											{
												tag: 'vaadin-upload',												
												itemid: 'uploadField',
												'no-auto':  true,
												'max-files': 1,
												required: true,												
												target: '/api/resource/reports/upload',
												headers: ImportUtil.getUploadHeader(),
												listeners: {
													'upload-request': function(event) {
														var data = uploadFormPanel.getData();	
																												
														event.detail.formData.append('reportType', selectedReportType.reportType);
														event.detail.formData.append('reportTypeDescription', selectedReportType.reportTypeDescription);
																												
														if (reportGrid.admin) {
															var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
															event.detail.formData.append('companyId', selectedCompany);
														}
														
														if (data.note) {
															event.detail.formData.append('note', data.note);
														}
														if (data.reportBeginDts) {
															var dateWithZone = TimeUtil.addCompanyTimeZone(data.reportBeginDts);
															event.detail.formData.append('reportBeginDts', dateWithZone);
														}
														if (data.reportEndDts) {
															var dateWithZone = TimeUtil.addCompanyTimeZone(data.reportEndDts);
															event.detail.formData.append('reportEndDts', dateWithZone);														
														}
														if (data.finalized) {
															event.detail.formData.append('finalized', data.finalized);														
														}
													},
													'upload-response': function(event) {
													},
													'upload-success': function(event) {
														var responseData = JSON.parse(event.detail.xhr.responseText);
														if (responseData.errors) {
															uploadFormPanel.markFields(responseData.errors);															
														} else {
															actionRefresh();
															uploadWin.close();
														}
													}
												}
											}
										]
									},									
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});				
		};			
			
		var actionDownload = function(record) {
			Service.getReportService().downloadReport(record.reportId, null, reportCompanyId(record));
		};			
			
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected report?' + (record.finalized ? '<br><b>WARNING: This a Finalized report</b>': ''),
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Report...');

							Service.getReportService().deleteReport(record.reportId, reportCompanyId(record))
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Report', {									
									theme: 'success'
								});
								actionRefresh();
							})
							.catch(function(){
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
					
		};	
				
	}
	
}
customElements.define('dl-report-grid', ReportGrid);

